import { CheckSingleIcon } from 'src/domains/layouts/shared/assets/icons/CheckSingleIcon';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

import styled from '@emotion/styled';

import { withConfig } from 'src/withConfig';

import { css, SerializedStyles } from '@emotion/react';

import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';



interface FakeCheckboxWrapperPropsType {

    isSelected: boolean;

    mode: 'dark' | 'light';

    variant: DefaultComponentVariantType | null;

}



const fakeCheckboxStyled = (theme: EmotionTheme, isSelected: boolean, mode: 'dark' | 'light'): SerializedStyles | undefined => {

    if (mode === 'light') {

        if (isSelected) {

            return css`

                background-color: ${theme.star.checkbox.light.bgColorSecondary};

                border-color: ${theme.star.checkbox.light.borderColorSecondary};

            `;

        }

        return css`

            background-color: ${theme.star.checkbox.light.bgColor};

            border-color: ${theme.star.checkbox.light.borderColor};

        `;

    }



    if (isSelected) {

        return css`

            background-color: ${theme.star.checkbox.dark.bgColorSecondary};

            border-color: ${theme.star.checkbox.dark.borderColorSecondary};

        `;

    }

    return css`

        background-color: ${theme.star.checkbox.dark.bgColor};

        border-color: ${theme.star.checkbox.dark.borderColor};

    `;

};



const setFakeCheckboxWrapper = (variant: DefaultComponentVariantType | null): SerializedStyles | undefined => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            display: flex;

            align-items: center;

            justify-content: center;

        `;

    }

    return css``;

};



export const FakeCheckboxWrapper = withConfig(theme => styled('div', { label: 'FakeCheckboxWrapper' })<FakeCheckboxWrapperPropsType>`

    ${({ isSelected, mode }): SerializedStyles | undefined => fakeCheckboxStyled(theme, isSelected, mode)}

    ${({ variant }): SerializedStyles | undefined => setFakeCheckboxWrapper(variant)}

    border-radius: 2px;

    border-style: solid;

    border-width: 2px;

    height: 20px;

    width: 20px;

    display: flex;

    justify-content: center;

`);



export const FakeCheckboxCheckIcon = withConfig(theme => styled(CheckSingleIcon, { label: 'FakeCheckboxCheckIcon' })`

    fill: ${theme.star.checkbox.bgColor};

    width: 12px;

`);

